export default __webpack_public_path__ + "static/media/gallery_00.66ff2183.jpg";